import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "loans-to-refinance-section-header-wrapper" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "loans-to-refinance-section-wrapper" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "step-btns" }

import { ref, computed, onMounted, watch, onUnmounted } from "vue";
import { useStore } from "vuex";
import { UpdateRefiLoansRequest } from "@/models/vuex";
import Modal from "@/components/shared/Modal.vue";
import DialogueModal from "@/components/modals/DialogueModal.vue";
import LoansToRefinanceTable from "@/components/refi-loans-table/LoansToRefinanceTable.vue";
import NextButton from "@/components/shared/NextButton.vue";
import CircleLoader from "@/components/shared/CircleLoader.vue";
import _ from "lodash";


export default /*@__PURE__*/_defineComponent({
  __name: 'RefiLoanDetailsModal',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const showDialogueModal = ref<boolean>(false);

const emit = __emit;

const gettingData = ref<boolean>(true);
const savingChanges = ref<boolean>(false);
const discardingChanges = ref<boolean>(false);

const showPayoffDetails = computed(() =>
  store.state.applicationInfoModule.currentlyActiveModals?.includes("ConfirmYourRefinanceDetails"),
);
const updatingRefiLoans = computed(() => store.state.applicationInfoModule?.updatingRefiLoans);
const loans = computed(() => store?.getters["applicationInfoModule/RefiLoans"]);
const emailAddress = computed(() => store.getters["contactUs"]?.email);
const currentApplicant = computed(() => store.state.appData.currentApplicant);
const finalDocumentationStipExists = computed(
  () => store.getters["checklistModule/finalDocumentationStipExists"],
);
const updateRefiLoansError = computed(
  () => store.getters["applicationInfoModule/updateRefiLoansError"],
);

const minimumLoanAmount = computed(() => store.getters["PROGRAM_MINIMUM_LOAN_AMOUNT"]);

const minimumLoanAmountDisplay = computed(
  () => store.getters["PROGRAM_MINIMUM_LOAN_AMOUNT_DISPLAY"],
);

const calculatedEstimatedTotalToRefinance = computed<boolean>(
  () => store.state.applicationInfoModule.calculatedEstimatedTotalToRefinance,
);

const loanMinNotMetError = computed<boolean>(
  () => calculatedEstimatedTotalToRefinance.value < minimumLoanAmount.value,
);

function openDialogueModal() {
  showDialogueModal.value = true;
}

function handleDialogueModal() {
  store.dispatch("applicationInfoModule/discardChanges");
  store.dispatch("applicationInfoModule/closeModal", "LoanDetails");
  showDialogueModal.value = false;
}

function closeModal() {
  openDialogueModal();
}

async function confirmChanges() {
  savingChanges.value = true;

  if (!loanMinNotMetError.value) {
    const updateRefiLoansRequest = {
      applicationId: store.state.appData?.application?.id,
      applicantId: currentApplicant.value?.id,
      request: loans.value,
    } as UpdateRefiLoansRequest;

    await store.dispatch("applicationInfoModule/updateRefiLoans", updateRefiLoansRequest);
  } else {
    savingChanges.value = false;
  }
}

async function getRefiLoanDetailsModal() {
  await store.dispatch(
    "applicationInfoModule/getRefiLoanModalData",
    store.state.appData?.application?.id,
  );

  gettingData.value = false;
}

onMounted(() => {
  gettingData.value = true;
  getRefiLoanDetailsModal();
  const originalRefiLoans = _.cloneDeep(loans.value);
  store.commit("applicationInfoModule/SET_ORIGINAL_REFI_LOANS", originalRefiLoans);
});

onUnmounted(() => {
  store.dispatch(
    "applicationInfoModule/setCalculatedEstimatedTotalToRefinance",
    store?.state?.applicationInfoModule?.applicationInfo?.estimatedTotal,
  );
});

watch(
  () => updateRefiLoansError.value,
  async (value: any) => {
    if (value) {
      savingChanges.value = false;
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "loan-details-modal",
    closeBtn: true,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      _withDirectives(_createElementVNode("div", { class: "error" }, _toDisplayString(minimumLoanAmountDisplay.value) + " is the minimum refinance amount. ", 513), [
        [_vShow, loanMinNotMetError.value]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(NextButton, {
          text: "Cancel",
          onClick: _withModifiers(closeModal, ["prevent"]),
          disabled: savingChanges.value || discardingChanges.value,
          loading: discardingChanges.value
        }, null, 8, ["disabled", "loading"]),
        _createVNode(NextButton, {
          text: "Save Changes",
          onClick: _withModifiers(confirmChanges, ["prevent"]),
          disabled: savingChanges.value,
          loading: savingChanges.value
        }, null, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "title" }, "Loan Details", -1)),
        _createElementVNode("p", null, [
          _cache[1] || (_cache[1] = _createTextVNode(" If the payoff information below is incorrect or if you wish to pay off an additional loan from your pre-approved loan amount, please contact ", -1)),
          _createElementVNode("a", {
            class: "email-link",
            href: `mailto:${emailAddress.value}`
          }, _toDisplayString(emailAddress.value) + ".", 9, _hoisted_2)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (gettingData.value)
          ? (_openBlock(), _createBlock(CircleLoader, {
              key: 0,
              inline: true
            }))
          : (_openBlock(), _createBlock(LoansToRefinanceTable, {
              key: 1,
              showPayoffDetails: showPayoffDetails.value,
              showActionsColumn: true,
              showTableHeader: false,
              showAddLoanButton: true,
              showIncludedLoansOnly: finalDocumentationStipExists.value,
              id: "Parent_LoanDetailsModal"
            }, null, 8, ["showPayoffDetails", "showIncludedLoansOnly"]))
      ]),
      (showDialogueModal.value === true)
        ? (_openBlock(), _createBlock(DialogueModal, {
            key: 0,
            onCancel: _cache[0] || (_cache[0] = ($event: any) => (showDialogueModal.value = false)),
            onConfirm: handleDialogueModal,
            title: `Quit editing?`,
            msg: `Any changes you\'ve made so far will not be saved`,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
          }))
        : _createCommentVNode("", true),
      (updateRefiLoansError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " An error occurred while processing your request. Please try again later. If the issue persists, please contact our support team. "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})